import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M18.52 20.978C17.69 21.238 8.201 21.118 8.201 21.118C8.201 21.118 0.282004 21.608 2.342 12.03C3.092 9.36096 4.122 12.63 5.712 12.5C5.712 12.5 7.802 12 9.002 12C11.49 12 11.355 11.9 10.312 10.38C10.002 9.94996 9.752 9.46996 9.592 8.93996C8.822 6.44096 10.142 3.80096 12.562 3.05096C14.882 2.33096 17.371 3.63096 18.241 5.96996C18.241 5.96996 19.331 6.10996 19.761 5.96996C20.191 5.83996 20.661 5.45996 20.661 5.45996C20.661 5.45996 21.181 6.06996 20.621 7.00996C20.071 7.95996 19.351 8.54996 19.351 8.54996C19.351 8.54996 20.811 8.97996 20.991 9.01996C21.181 9.05996 20.681 10.01 19.621 10.38C18.561 10.74 18.311 11 18.241 11.38L18.261 11.6C18.281 11.82 18.451 12.01 18.671 12.06C19.781 12.29 21.301 13.48 21.801 15.119C22.56 17.559 21.09 20.189 18.52 20.978Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'DuckFill');

export default Icon;
